
const { matchPid } = require('../utilities/ProductPage');
const { addCSSLink } = require('../utilities/ScriptStylesheetHelper');


const whiteList = [9679, 9642, 9718, 9719, 9717, 9716, 8889, 6441/* for test*/];
//const whiteList = [6441];
const pid = matchPid(...whiteList);
let url = '/WebPage/1079/';
if(window.CountryCode == "tw"){
    url = window.UrlCountryCode + url;
}

if(pid){
    addCSSLink('/WebPage/999/innergigabyte/css/AI_side_ad.css');
    let container = document.createElement('div');
    container.classList.add('product_side_icon');

    let icon = document.createElement('a');
    icon.classList.add('icon');
    icon.title = "GIGABYTE AI TOP";
    icon.target = "_blank";
    icon.href = url;
    icon.setAttribute('onclick', "SendGaEvent('ModelPage', 'Side-Ad', 'LandingPage:GIGABYTE AI TOP')");

    container.appendChild(icon);
    document.body.appendChild(container);
}